/**
 * Build full image URL using imageBaseUrl from API response
 */
export const buildImageUrl = (path, imageBaseUrl) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  // ✅ imageBaseUrl API se aayega
  const base = (imageBaseUrl || '').replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  return `${base}${cleanPath}`;
};